export default __webpack_public_path__ + "static/media/NFT4.045d359c.png";